import template from "./information.html";
import en from "./en.json";
import es from "./es.json";

class InformationController {
    constructor($element, $scope, $window) {
        "ngInject";

        let ctrl = this;
        ctrl.$element = $element;
        ctrl.$window = $window;
        ctrl.tooltipId = `information-${$scope.$id}`;
        ctrl.positionFrame = null;
        ctrl.isHovered = false;
        ctrl.isFocused = false;
        ctrl.dismissOutsidePointer = (event) => {
            if (!ctrl.$element[0].contains(event.target)) {
                ctrl.hide();
            }
        };
        ctrl.dismissEscape = (event) => {
            if (event.key === "Escape") {
                ctrl.hide();
            }
        };
        ctrl.queuePositionUpdate = () => {
            if (ctrl.positionFrame !== null) {
                return;
            }
            ctrl.positionFrame = ctrl.$window.requestAnimationFrame(() => {
                ctrl.positionFrame = null;
                if (ctrl.isOpen) {
                    ctrl.updatePosition();
                }
            });
        };
    }

    show() {
        let ctrl = this;
        ctrl.$element[0].querySelector("[popover]").showPopover();
        ctrl.updatePosition();
        if (!ctrl.isOpen) {
            ctrl.isOpen = true;
            ctrl.$window.addEventListener(
                "pointerdown",
                ctrl.dismissOutsidePointer,
                {
                    capture: true,
                    passive: true,
                },
            );
            ctrl.$window.addEventListener("keydown", ctrl.dismissEscape, true);
            ctrl.$window.addEventListener("scroll", ctrl.queuePositionUpdate, {
                capture: true,
                passive: true,
            });
            ctrl.$window.addEventListener("resize", ctrl.queuePositionUpdate);
        }
    }

    setInteractionState(interaction, isActive) {
        let ctrl = this;
        ctrl[interaction] = isActive;
        if (isActive) {
            ctrl.show();
        } else if (!ctrl.isHovered && !ctrl.isFocused) {
            ctrl.hide();
        }
    }

    updatePosition() {
        let ctrl = this;
        let trigger = ctrl.$element[0].querySelector("button");
        let popup = ctrl.$element[0].querySelector("[popover]");
        let bounds = trigger.getBoundingClientRect();
        let width = Math.min(288, ctrl.$window.innerWidth - 32);
        let left = Math.max(
            16,
            Math.min(bounds.left, ctrl.$window.innerWidth - width - 16),
        );

        popup.style.width = `${width}px`;
        popup.style.left = `${left}px`;
        popup.style.top = `${bounds.bottom}px`;

        let height = popup.getBoundingClientRect().height;
        if (bounds.bottom + height > ctrl.$window.innerHeight - 16) {
            popup.style.top = `${Math.max(16, bounds.top - height)}px`;
        }
    }

    hide() {
        let ctrl = this;
        ctrl.isOpen = false;
        ctrl.$window.removeEventListener(
            "pointerdown",
            ctrl.dismissOutsidePointer,
            true,
        );
        ctrl.$window.removeEventListener("keydown", ctrl.dismissEscape, true);
        ctrl.$window.removeEventListener(
            "scroll",
            ctrl.queuePositionUpdate,
            true,
        );
        ctrl.$window.removeEventListener("resize", ctrl.queuePositionUpdate);
        if (ctrl.positionFrame !== null) {
            ctrl.$window.cancelAnimationFrame(ctrl.positionFrame);
            ctrl.positionFrame = null;
        }
        ctrl.$element[0].querySelector("[popover]").hidePopover();
    }

    $onInit() {
        let ctrl = this;
        ctrl.$element.addClass("h-5");
    }

    $onDestroy() {
        let ctrl = this;
        ctrl.hide();
    }
}

export default {
    name: "information",
    bindings: {
        translationKey: "@",
    },
    controller: InformationController,
    template,
    translations: {
        en,
        es,
    },
};
